import angular from 'angular';
import { localStorage } from '../../utils';
import { get } from 'lodash';
import '../../app.constants';
import '../../services/globals';
import '../../services/organization';
import '../../services/queue';
import '../../services/place';
import '../../services/errors';
import '../../services/user';
import '../../services/notifications';
import '../modals/organizations';
import { CallingAutomaticallyStatus, CallingAutomaticallyReason } from '../../enums/callingAutomatically';

const module = angular.module('whyline.controllers.organizations.list', [
  'whyline.constants',
  'whyline.services.globals',
  'whyline.services.organization',
  'whyline.services.queue',
  'whyline.services.place',
  'whyline.services.errors',
  'whyline.services.user',
  'whyline.services.notifications',
  'whyline.modals.organization',
]);

const OrganizationsListController = (SAFE_STATES, $rootScope, $scope, $state, $timeout, OrganizationService, QueueService, PlaceService, GlobalsService, ErrorService, NotificationService, UserService, $translate, $uibModal, dialog) => {
  /*@ngInject*/

  GlobalsService.SetCurrentPlace(null);
  GlobalsService.SetCurrentOrganization(null);

  const user = localStorage.get('user');
  const userId = get(user, '_id', '');

  // TODO: This is bug VV1-1606, it needs to be fixed in order to allow the organization admin 
  // to access the organization list even if there's only 1 (so he can edit his own)
  // Bug description says this needs to be reviewed when plans gets implemented
  const roleName = get(user, 'permissions[0].role.name', '');

  $scope.superAdmin = user && user.sudo;

  const showOrganizations = $scope.superAdmin || roleName === 'Organization Admin';

  $scope.queryOrganizations = () => {
    OrganizationService.GetAllAsPromise()
      .then(organizations => {
        $timeout(() => {
          if (Object.keys(organizations).length === 1 && !showOrganizations && organizations[Object.keys(organizations)[0]].enabled) {
            GlobalsService.SetSingleOrganization(true);
            $scope.selectOrganization([Object.values(organizations)[0]][0]);
          } else {
            GlobalsService.SetSingleOrganization(false);
          }

          $scope.organizations = organizations;

          for (const idKey in organizations) {
            organizations[idKey].users.forEach(u => {
              if (u === user._id) {
                organizations[idKey].userCanEdit = true;
              }
            });

            organizations[idKey].canUseOrganization = (organizations[idKey].enabled) || $scope.superAdmin;
            organizations[idKey].canEditOrganization = (organizations[idKey].enabled && organizations[idKey].userCanEdit) || $scope.superAdmin;

            if (!organizations[idKey].enabled) {
              organizations[idKey].editTooltip = 'organization_disabled';
            }
            else if (!organizations[idKey].userCanEdit) {
              organizations[idKey].editTooltip = 'do_not_have_permission';
            }
          }
        });
      })
      .catch(ErrorService.handler);
  };

  if (get(user, 'callingAutomatically.status', CallingAutomaticallyStatus.Paused) === CallingAutomaticallyStatus.Active) {
    const serviceType = get(user, 'callingAutomatically.serviceType', '') || '';
    const serviceId = get(user, 'callingAutomatically.serviceId', '') || '';

    if (serviceType && serviceId) {
      const queueQuery = {[`${serviceType}Id`]: serviceId};

      QueueService.GetByIdAndType(serviceId, serviceType).then((queue) => {
        const placeId = get(queue, 'placeId', '') || '';

        if (placeId) {
          PlaceService.GetOneAsPromise(placeId).then((place) => {
            const organizationId = get(place, 'organizationId', '') || '';

            if (organizationId) {
              NotificationService.Success($translate.instant('redirecting to the service with automatic call activated'));

              const nowServingQueueParams = Object.assign({}, queueQuery, { placeId, organizationId });
              return $state.go(SAFE_STATES.nowServingQueue, nowServingQueueParams);
            } else {
              $scope.pauseUserCallingAutomatically();
            }
          }).catch(ErrorService.handler);
        } else {
          $scope.pauseUserCallingAutomatically();
        }
      }).catch(ErrorService.handler);
    } else {
      $scope.pauseUserCallingAutomatically();
    }
  } else {
    $scope.queryOrganizations();
  }

  $scope.pauseUserCallingAutomatically = () => {
    const callingAutomatically = {
      status: CallingAutomaticallyStatus.Paused,
      reason: CallingAutomaticallyReason.NotValidData,
      serviceId: '',
      serviceType: '',
      userId,
    };

    UserService.UpdateCallingAutomaticallyStatus(userId, callingAutomatically);

    $scope.queryOrganizations();
  };

  $scope.selectOrganization = organization => {
    OrganizationService.SetCurrent(organization);
    $state.go(SAFE_STATES.placesList, { organizationId: organization._id });

    $rootScope.$emit('organization-join', organization._id);
  };

  $scope.edit = organizationId => {
    $uibModal.open({
      templateUrl: '/templates/components/modals/organizations-modal/index.html',
      size: 'lg',
      controller: 'OrganizationModalController',
      resolve: {
        organizationId: () => organizationId,
        superAdmin: () => $scope.superAdmin
      }
    });
  };

  $scope.switch = organization => {
    OrganizationService.SwitchOrganizationEnable(organization);
  }

  $scope.logoutUsers = organizationId => {
    dialog
      .confirm(
        $translate.instant('user_mass_logout_sure'),
      )
      .then(() => {
        UserService.MassUserLogoutForOrganization(organizationId)
          .then(() => {
            NotificationService.Success(
              $translate.instant('user_mass_logout_succ'),
            );
          })
          .catch(ErrorService.handler);
      });
  };

};

export default module.controller('OrganizationsListController', OrganizationsListController);
